import type { DayView } from '@tabel/shared/schemas/rules';
import { BookmarkPlus } from 'lucide-react';
import { createContext, useContext } from 'react';
import { IconButton } from '../../components/ui';
import type { OpenDay } from './ExampleDay';
import { LABEL } from './texts';

/*
 * «Сделать проверочным примером» (004, US5, T095; FR-051): страница даёт эту команду через контекст — у примера
 * правила, в «Выбрать день» и в списке дней влияния. Команда есть только у администратора правил (таблица «Права
 * ролей»); у других ролей контекст пуст, и кнопок нет. Окно примера одно — на странице.
 */

/** Открыть окно примера для дня; `view` — день уже посчитан (пример правила), окно не спрашивает его снова. */
export type PinDay = (day: OpenDay, view?: DayView) => void;

export const PinContext = createContext<PinDay | null>(null);

/** Команда «Сделать проверочным примером»; `null` — роль не может закреплять примеры. */
export function usePin(): PinDay | null {
  return useContext(PinContext);
}

/** Кнопка-ссылка под примером дня — как «Открыть расчёт дня». */
export function PinLink({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="-mx-1 inline-flex items-center gap-1 rounded-control px-1 text-[12.5px] font-medium text-accent hover:underline max-sm:min-h-10"
    >
      <BookmarkPlus size={14} strokeWidth={1.75} aria-hidden />
      {LABEL.pin}
    </button>
  );
}

/** Кнопка в строке дня влияния: значок, подпись — для чтения с экрана и в подсказке. */
export function PinIconButton({ onClick }: { onClick: () => void }) {
  return <IconButton icon={BookmarkPlus} label={LABEL.pin} onClick={onClick} className="mr-1" />;
}
